import React from "react";
import { Divider } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { validate as validateEmail } from "react-email-validator";
import { SendResetPasswordLink } from "../../engine/baseApiClient";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

function ResetPasswordComponent() {
  const [isEmailProvided, setisEmailProvided] = React.useState(true);
  const [isResetLinkSent, setIsResetLinkSent] = React.useState(false);
  const [isResetLinkSendingError, setIsResetLinkSendingError] = React.useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setisEmailProvided(true);

    const data = new FormData(e.currentTarget);
    if (!validate(data)) {
      return;
    }
    var userData = {
      email: data.get("email"),
    };
    var response = await SendResetPasswordLink(userData);
    if (response.status == "OK") {
      setIsResetLinkSent(true);
      setIsResetLinkSendingError(false);
    }
    else{
      setIsResetLinkSent(false);
      setIsResetLinkSendingError(true);
    }
  };

  const validate = (data) => {
    var isValid = true;
    var email = data.get("email");
    if (email == "") {
      isValid = false;
      setisEmailProvided(false);
    }
    if (!validateEmail(email)) {
      isValid = false;
      setisEmailProvided(false);
    }
    return isValid;
  };

  return (
    <MDBox component="form" onSubmit={handleSubmit} noValidate>
      <MDInput
        id="logon-email-field"
        margin="normal"
        required
        fullWidth
        label="Twój adres e-mail"
        error={!isEmailProvided}
        name="email"
        helperText={!isEmailProvided ? "Niepoprawny email" : ""}
        autoComplete="email"
        autoFocus
      />
     
      {isResetLinkSent && (
        <MDTypography
          sx={{ mt: 2 }}
          color="success"
          fontSize={14}
          margin="normal"
          align="center"
          fullWidth
          name="invalid-data"
        >
          Wysłano link do zresetowania hasła
        </MDTypography>
      )}
       {isResetLinkSendingError && (
        <MDTypography
          sx={{ mt: 2 }}
          color="error"
          fontSize={14}
          margin="normal"
          align="center"
          fullWidth
          name="not-send"
        >
          Nie odnaleziono użytkownika o podanym adresie email
        </MDTypography>
      )}
      <MDButton
        type="submit"
        id="login"
        fullWidth
        variant="contained"
        color="info"
        sx={{ mt: 2, mb: 2, textTransform:'none', fontSize:"14px" }}>
           Wyślij
      </MDButton>
    </MDBox>
  );
}
export default ResetPasswordComponent;
